import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'error-snack-bar',
  templateUrl: '../templates/notification.component.html',
  styleUrl: '../templates/styles/notification.component.css',
})
export class NotificationComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private snackBarRef: MatSnackBarRef<NotificationComponent>) { }

  close() {
    this.snackBarRef.dismiss(); // Закрытие Snackbar
  }
}
